import { Request } from "../Request";

export function getWebsite(id: string) {
  return Request.get(`websites/subpage/${id}`, {});
}

export function getWebsiteByDomain(domain: string) {
  return Request.get(`websites/subpageDomain/${domain}`, {});
}
